import { filterShowHide, loadPosts, selectRouter } from '../modules/collection';


export default {
	init() {
		// JavaScript to be fired on all pages
		loadPosts();
		filterShowHide();
	},
	finalize() {
		selectRouter();
		// JavaScript to be fired on all pages, after page specific JS is fired
	},
};



// WEBPACK FOOTER //
// ./scripts/routes/archive.js